module.exports = __webpack_public_path__ + "media/images/emblems/Saas_Grund_Wappen-664735fa10d1bc8d3eaf4d36675c9a10.png";